import { resolveSupportedLocale, type SupportedLocale } from '@runtime/core/i18n/localeConfig'
export const CHALLENGE_SHARE_PREFIX = '/challenges/s/'
export type ChallengeShareIdentity = {
  id: string
  revision: string
  locale: SupportedLocale
  variant?: string
}
export function readChallengeSharePath(pathname: string): ChallengeShareIdentity | null {
  if (!pathname.startsWith(CHALLENGE_SHARE_PREFIX)) return null
  const parts = pathname.slice(CHALLENGE_SHARE_PREFIX.length).replace(/\/$/, '').split('/')
  if (parts.length !== 4) return null
  const [id, revision, locale, variant] = parts
  if (!/^(place|assemble|reason|win)-\d{2}$/.test(id) || !/^magnetic1-[a-f0-9]{8}$/.test(revision))
    return null
  if (resolveSupportedLocale(locale) !== locale || !/^(?:_|[A-Za-z0-9-]{1,32})$/.test(variant))
    return null
  return {
    id,
    revision,
    locale: locale as SupportedLocale,
    ...(variant !== '_' ? { variant } : {}),
  }
}
export function challengeSharePath(value: ChallengeShareIdentity) {
  return (
    CHALLENGE_SHARE_PREFIX +
    [value.id, value.revision, value.locale, value.variant || '_'].map(encodeURIComponent).join('/')
  )
}
// Construct anew: never forward a query, account data, author document or play state.
export function challengeShareUrl(value: ChallengeShareIdentity, origin: string) {
  const base = new URL(origin)
  if (!['http:', 'https:'].includes(base.protocol)) throw new Error('unsupported_share_origin')
  return new URL(challengeSharePath(value), base.origin).href
}
export function challengeShareArrivalParams(pathname: string, search: string) {
  if (!pathname.startsWith(CHALLENGE_SHARE_PREFIX)) return new URLSearchParams(search)
  const identity = readChallengeSharePath(pathname)
  const params = new URLSearchParams()
  if (!identity) {
    params.set('challenge', 'invalid-share')
    return params
  }
  params.set('challenge', identity.id)
  params.set('revision', identity.revision)
  if (identity.variant) params.set('variant', identity.variant)
  return params
}

export function isReviewShareOrigin(origin: string) {
  const hostname = new URL(origin).hostname
  return (
    /^(localhost|127\.|192\.168\.|10\.|172\.(1[6-9]|2\d|3[01])\.|\[::1\]|\[(?:fc|fd|fe80:))/.test(
      hostname,
    ) || /\.(localhost|local|lan|test|invalid|home\.arpa)$/.test(hostname)
  )
}
